<div class="p-4 pt-3" style="width: 450px">
  <div class="d-flex align-items-center justify-content-between mb-3">
    <h5 class="mb-0">Choose {{ entityLabel }}</h5>
    <img
      src="assets/images/close-icon.svg"
      alt="close-icon"
      (click)="closeDialog()"
      class="cursor-pointer"
      [attr.aria-hidden]="true" />
  </div>

  <form class="mat-form">
    <mat-form-field appearance="outline">
      <mat-label>Choose {{ entityLabel }}</mat-label>
      <mat-select
        [formControl]="senderRecipientCtrl"
        panelClass="existing-user-select-panel"
        #singleSelect>
        <mat-select-trigger>
          {{ formatSelected(senderRecipientCtrl.value) }}
        </mat-select-trigger>
        <mat-option>
          <ngx-mat-select-search
            [formControl]="senderRecipientFilterCtrl"
            [placeholderLabel]="'Find ' + entityLabel.toLowerCase()"
            [noEntriesFoundLabel]="
              'No matching ' + entityLabel.toLowerCase() + ' found'
            ">
          </ngx-mat-select-search>
        </mat-option>
        <mat-option
          *ngFor="
            let option of filteredOptions | async;
            trackBy: trackById
          "
          [value]="option.raw">
          <div class="d-flex flex-column lh-sm py-1">
            <span class="option-name">{{ option.name }}</span>
            <small class="option-email text-muted">{{ option.email }}</small>
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
  <button class="btn primary-btn w-100" (click)="closeDialog()">Submit</button>
</div>
